import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actionCreators from "../actions/actionCreators.js";


import OBSsheets from "../components/OBSsheets";


function mapStateToProps(state){
	//console.log("Connecting state", state.series);
	return {
		lang: state.data.lang,
		auth: state.data.auth,
	}
}

function mapDispatchToProps(dispatch){
	return bindActionCreators(actionCreators, dispatch);
}


const OBSsheetsContainer = connect(mapStateToProps, mapDispatchToProps)(OBSsheets);

export default OBSsheetsContainer;


// WEBPACK FOOTER //
// ./src/containers/OBSsheetsContainer.js